import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/index.vue'
import search from '@/views/search/search.vue'
import detail from '@/views/detail/index.vue'
// 龙虎榜能力下架：原 list / stock-detail / sales-department 统一落地 404 无数据态
import DragonTigerOffline from '@/views/dragon-tiger-table/offline'
import Login from '@/views/login/index.vue'
import Send from '@/views/guba/send/index.vue'
import viewDetail from '@/views/guba/detail/index.vue'
import Protocol from '@/views/protocol/index.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/:market/:code.html',
    name: 'index',
    component: Home,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/search.html',
    name: 'search',
    component: search,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/detail/:market/:code/:type/:id.html',
    name: 'detail',
    component: detail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/send/:market/:code/send.html',
    name: 'send',
    component: Send,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/viewDetail/:market/:code/:id.html',
    name: 'viewDetail',
    component: viewDetail,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/protocol/:market/:code/:id.html',
    name: 'protocol',
    component: Protocol,
    meta: {
      keepAlive: false
    }
  },
  // {
  //   path: '/list',
  //   component: List,
  //   children: [{
  //     path: 'league',
  //     name: 'league',
  //     component: DragonList,
  //     meta: {
  //       keepAlive: true
  //     }
  //   }, {
  //     path: 'sales',
  //     name: 'sales',
  //     component: SalesList,
  //     meta: {
  //       keepAlive: true
  //     }
  //   }],
  //   meta: {
  //     keepAlive: false
  //   }
  // }
  {
    path: '/stock-list.html',
    component: DragonTigerOffline,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/stock/detail/:id.html',
    name: 'stockdetail',
    component: DragonTigerOffline,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/department/detail/:id.html',
    name: 'departmentDetail',
    component: DragonTigerOffline,
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/login.html',
    name: 'login',
    component: Login,
    meta: {
      keepAlive: false
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production'
    ? '/wap/'
    : '/richbays-wap/',
  routes
})

export default router
